import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { DevicePreviews } from '../components/review/DevicePreviews';
import { DesignGuide } from '../components/review/DesignGuide';
export function ReviewPage() {
  return <div className="min-h-screen w-full bg-paper font-sans text-carbon" data-id="element-196" data-mp="3ugz50ul8ie6">
      <header className="border-b border-sand" data-id="element-197" data-mp="8uuzdwpy6o1n">
        <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-10 sm:flex-row sm:items-end sm:justify-between lg:px-10" data-id="element-198" data-mp="38ars0c5pr4op">
          <div data-id="element-199" data-mp="3cd4wyycmyykf">
            <p className="text-sm text-stone" data-id="element-200" data-mp="3ccmsjeftle1f">Buena VibraX · Propuesta para revisión</p>
            <h1 className="mt-2 font-serif text-4xl tracking-tight" data-id="element-201" data-mp="3haemsf3xtc8s">
              El valor de <em className="italic text-gold-ink" data-id="element-202" data-mp="3m26hn1u4m44q">comenzar</em>
            </h1>
          </div>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-medium underline decoration-gold decoration-2 underline-offset-4" data-id="element-203" data-mp="2onamuojpbo3v">
            Abrir la página completa
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-204" data-mp="kfbyhzywtvrj" />
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-6xl space-y-24 px-6 py-16 lg:px-10" data-id="element-205" data-mp="gftohz8mn53h">
        <section aria-labelledby="vistas-titulo" data-id="element-206" data-mp="bna16ak50vlh">
          <h2 id="vistas-titulo" className="font-serif text-3xl" data-id="element-207" data-mp="blyyke2fhtvy">Móvil y escritorio</h2>
          <p className="mt-3 text-base text-stone" data-id="element-208" data-mp="6n4el8sq5za9">Ambas vistas son navegables: desplázate dentro de cada una.</p>
          <div className="mt-8" data-id="element-209" data-mp="3swf268yk2v0g">
            <DevicePreviews data-id="element-210" data-mp="3sw5l5avhny6w" />
          </div>
        </section>
        <DesignGuide data-id="element-211" data-mp="3outur34sj8xn" />
      </main>
    </div>;
}